const IMG_A =
  "https://readdy.ai/api/search-image?query=documentary%20photography%20empty%20green%20room%20backstage%2C%20single%20hot%20stage%20light%20and%20chair%2C%20dust%20in%20warm%20beam%2C%20moody%20minimal%20composition%2C%20film%20grain%2C%20editorial%20warm%20tonal%20grade&width=600&height=420&seq=timeline-a-x1&orientation=landscape";
const IMG_B =
  "https://readdy.ai/api/search-image?query=close%20up%20smartphone%20glowing%20screen%20held%20in%20hands%20at%20night%2C%20blurred%20warm%20city%20lights%20background%2C%20notifications%20and%20messages%20blurred%2C%20cinematic%20candid%2C%20editorial%20warm%20tone&width=600&height=420&seq=timeline-b-x1&orientation=landscape";
const IMG_C =
  "https://readdy.ai/api/search-image?query=interview%20microphone%20and%20notepad%20on%20table%20by%20window%20with%20warm%20evening%20light%2C%20documentary%20journalism%20flat%20lay%2C%20candid%20reporting%20scene%2C%20editorial%20film%20grain%2C%20warm%20tones&width=600&height=420&seq=timeline-c-x1&orientation=landscape";

const EVENTS = [
  {
    time: "昨日 23:40",
    tag: "好友八卦",
    title: "闺蜜线爆料：散伙饭桌上一句话，让在场全员尴尬到低头",
    text: "多名当事人改口前的最后一条动态被翻出，时间对得严丝合缝。围观这场成人吃瓜好友八卦的网友，把当晚「谁先走的」盘成了连续剧。",
    img: IMG_A,
  },
  {
    time: "昨日 19:15",
    tag: "行业爆料",
    title: "行业爆料：某大厂新规落地前，一夜之间改了三次口径",
    text: "从内部流传的执行标准，到公开回应只用了七小时。跟单多年的老粉表示：这波行业爆料背后的博弈，比名单本身更耐人寻味。",
    img: IMG_B,
  },
  {
    time: "今日 08:02",
    tag: "幕后闹剧",
    title: "幕后闹剧再反转：道歉声明发出两小时后，当事人删光了配图",
    text: "声明与删除的时间差，被饭圈一帧一帧做成对比图。幕后闹剧的下一幕会走向和解，还是彻底三观炸裂？评论区先替我们把票投了。",
    img: IMG_C,
  },
];

export default function TimelineFeed() {
  return (
    <section id="timeline" className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        {/* header */}
        <div className="flex items-end justify-between gap-4 border-b-2 border-foreground-950 pb-4">
          <div>
            <p className="text-xs font-semibold tracking-[0.3em] text-primary-700">TIMELINE</p>
            <h3 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              昨日至今 · 吃瓜现场
            </h3>
          </div>
          <span className="hidden items-center gap-2 whitespace-nowrap rounded-full border border-foreground-300/50 bg-background-50 px-3 py-1.5 text-xs text-foreground-600 sm:flex">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-600"></span>
            </span>
            线稿持续更新中
          </span>
        </div>

        {/* timeline */}
        <ol className="relative mt-10 space-y-12 border-l border-foreground-300/40 pl-6 md:pl-10">
          {EVENTS.map((ev, idx) => (
            <li key={idx} className="relative">
              <span className="absolute -left-[31px] top-1 flex h-3.5 w-3.5 items-center justify-center md:-left-[43px]">
                <span className="h-3.5 w-3.5 rounded-full bg-accent-500 ring-4 ring-background-100"></span>
              </span>
              <div className="grid gap-5 lg:grid-cols-12 lg:gap-8">
                <div className="lg:col-span-4">
                  <div className="flex items-center gap-2">
                    <span className="whitespace-nowrap rounded bg-foreground-950 px-2 py-0.5 text-xs font-bold text-background-50">
                      {ev.time}
                    </span>
                    <span className="text-xs font-medium text-primary-700">{ev.tag}</span>
                  </div>
                  <h4 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                    <a href="#comment" className="hover:text-primary-700">
                      {ev.title}
                    </a>
                  </h4>
                  <p className="mt-3 hidden text-[15px] leading-relaxed text-foreground-600 md:block">
                    {ev.text}
                  </p>
                </div>
                <div className="lg:col-span-8">
                  <div className="overflow-hidden rounded-lg border border-foreground-200/60">
                    <img
                      src={ev.img}
                      alt={`成人吃瓜 ${ev.tag} ${ev.title}`}
                      title={`成人吃瓜 ${ev.tag}`}
                      className="h-56 w-full object-cover object-top md:h-72"
                    />
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-12 flex justify-center">
          <button
            type="button"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-foreground-300/60 bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            加载更早的吃瓜线
            <i className="ri-loader-4-line" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </section>
  );
}